import './terms-of-use.scss';

export const TERMS_OF_USE_URL = 'https://www.knowmeq.com/terms';

const TermsOfUse = ({text}: {text?: string}) =>
  <span className={'terms-of-use'} onClick={() => window.open(TERMS_OF_USE_URL)}>
  {text ? text : 'Terms of use'}
</span>

export default TermsOfUse;